<template>
  <v-card class="text-center" v-if="showMessage">
    <v-card-title class="headline justify-center">
      <span class="text-h4">{{
        $translate('CONFIRM_EMAIL_CHANGE_TITLE')
      }}</span>
    </v-card-title>

    <v-card-text style="font-size: large" v-html="resetEmailMessage" />

    <v-col cols="12" align-self="center" justify="center" align="center">
      <v-card flat class="pb-5">
        <v-btn
          color="primary"
          class="primary-font-color"
          depressed
          block
          large
          @click="onLogin"
        >
          {{ $translate('LOGIN') }}
        </v-btn>
      </v-card>
    </v-col>
  </v-card>

  <v-card v-else-if="showFailedMessage">
    <v-card-title class="headline justify-center">
      <span class="text-h4">{{ $translate('ERROR_EMAIL_CHANGE_TITLE') }}</span>
    </v-card-title>

    <v-card-text>
      {{ $translate('EMAIL_CHANGE_ERROR_MSG') }}
    </v-card-text>
    <v-col cols="12" align-self="center" justify="center" align="center">
      <v-card flat class="pb-5">
        <v-btn color="red" class="white" depressed block large @click="onClose">
          {{ $translate('CLOSE') }}
        </v-btn>
      </v-card>
    </v-col>
  </v-card>
</template>

<script>
import doRequest from '@/api/dssRequest';
import utility from '@/shared/utility';

export default {
  name: 'AccountConfirmEmailChange',
  data() {
    return {
      showMessage: false,
      showFailedMessage: false,
    };
  },
  created() {
    this.init();
  },
  computed: {
    resetEmailMessage() {
      return utility.sprintf(
        this.$translate('CONFIRM_EMAIL_CHANGE_DESC'),
        this.$route.query.NewEmail
      );
    },
  },
  methods: {
    init() {
      const payload = {};
      // Token to change email

      payload.ResetToken = this.$route.query.token;
      payload.NewEmail = this.$route.query.NewEmail;
      payload.UserId = this.$route.query.UserID;
      let ObjectId = this.$store.getters['auth/userName'];

      doRequest(
        this.onChangePasswordSucceed,
        this.onChangePasswordFail,
        'changeEmailNoLogin',
        payload.UserId,
        payload
      );
    },
    onChangePasswordSucceed() {
      this.showMessage = true;
    },
    onChangePasswordFail() {
      this.showFailedMessage = true;
    },
    onLogin() {
      this.$emit('triggerPopup', {
        toggle: true,
        component: 'Login',
        props: {
          initialEmail: this.$route.query.NewEmail,
        },
      });
    },
    onClose() {
      this.$emit('triggerPopup', { toggle: false, component: 'Login' });
      this.$emit('close');
    },
  },
};
</script>
